import { render, staticRenderFns } from "./EditorialSound.vue?vue&type=template&id=0c8c6fc6&scoped=true&"
import script from "./EditorialSound.vue?vue&type=script&lang=js&"
export * from "./EditorialSound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c6fc6",
  null
  
)

export default component.exports